import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "pannel-wrapper" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("label", null, "Component Reference", -1 /* HOISTED */);
const _hoisted_4 = ["value"];
import { onMounted, ref, watch, computed } from "vue";
import Button from "../ui/Button.vue";
import { useBuiltComponent, useBuiltComponents, useGlobalCampaignRootBuiltComponent, } from "src/shared/store/component-built/composables";
import DrawerTrigger from "src/shared/v-components/ui/drawer/DrawerTrigger.vue";
import NotificationEllipsis from "src/shared/v-components/ui/NotificationEllipsis.vue";
import AddComponentReferenceDrawer from "./AddComponentReferenceDrawer.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AddComponentReferenceBlock',
    props: {
        eventBus: {},
        component_ids: {}
    },
    emits: ["update:component_ids"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { builtComponents, primer } = useBuiltComponents();
        const { globalCampaignRootBuiltComponent } = useGlobalCampaignRootBuiltComponent();
        onMounted(() => {
            showExistingReference();
        });
        watch(primer, () => {
            showExistingReference();
        });
        const isOpen = ref(false);
        const displayName = ref("");
        const componentIdsProxy = computed({
            get() {
                return props.component_ids;
            },
            set(value) {
                emit("update:component_ids", value);
            },
        });
        const onComponentSelected = (component) => {
            displayName.value = component.getDisplayName();
            if (props.eventBus) {
                props.eventBus.trigger("set_component_id", component.id);
            }
            componentIdsProxy.value = [component.id];
            isOpen.value = false;
        };
        const showExistingReference = () => {
            if (primer.isReady && props.component_ids && props.component_ids[0]) {
                const { builtComponent } = useBuiltComponent(props.component_ids[0]);
                if (builtComponent.value) {
                    displayName.value = builtComponent.value.getDisplayName();
                    if (props.eventBus) {
                        props.eventBus.trigger("set_component_id", builtComponent.value.id);
                    }
                }
            }
        };
        const unlinkComponent = () => {
            displayName.value = "";
            if (props.eventBus) {
                props.eventBus.trigger("set_component_id", null);
            }
            componentIdsProxy.value = [];
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _hoisted_3,
                        (_unref(primer).isLoading)
                            ? (_openBlock(), _createBlock(NotificationEllipsis, { key: 0 }))
                            : (_openBlock(), _createElementBlock("input", {
                                key: 1,
                                value: displayName.value,
                                disabled: true
                            }, null, 8 /* PROPS */, _hoisted_4))
                    ])
                ]),
                _createVNode(DrawerTrigger, null, {
                    trigger: _withCtx(({ openDrawer }) => [
                        (_unref(primer).isReady)
                            ? (_openBlock(), _createBlock(Button, {
                                key: 0,
                                level: 'secondary',
                                onClick: openDrawer
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(" Add component reference ")
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    drawer: _withCtx(({ drawerClosed }) => [
                        (_unref(globalCampaignRootBuiltComponent))
                            ? (_openBlock(), _createBlock(AddComponentReferenceDrawer, {
                                key: 0,
                                globalCampaignRootBuiltComponent: _unref(globalCampaignRootBuiltComponent),
                                builtComponents: _unref(builtComponents),
                                onClosed: drawerClosed,
                                onComponentSelected: onComponentSelected
                            }, null, 8 /* PROPS */, ["globalCampaignRootBuiltComponent", "builtComponents", "onClosed"]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                }),
                (_unref(primer).isReady)
                    ? (_openBlock(), _createBlock(Button, {
                        key: 0,
                        level: 'secondary',
                        onClick: unlinkComponent
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(" Unlink component ")
                        ]),
                        _: 1 /* STABLE */
                    }))
                    : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
